import React from 'react';
import { useTranslation } from 'react-i18next';
import { Card, CardContent, Grid, Typography, TextField } from '@material-ui/core';
import useAuthContext from '../../../hooks/useAuthContext';
import { formatTimezoneLabel } from '../../../utils/farmDateTime';

const TimezoneSettings: React.FC = () => {
  const { t } = useTranslation();
  const { state } = useAuthContext();

  const label = state.farmTimeZoneId ? formatTimezoneLabel(state.farmTimeZoneId) : '—';

  return (
    <Card elevation={1}>
      <CardContent>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography color="primary" style={{ fontWeight: 500 }}>
              {t('f-settings-opt-timezone')}
            </Typography>
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              label={t('f-settings-opt-timezone-label')}
              value={label}
              variant="outlined"
              size="small"
              fullWidth
              disabled
              InputProps={{ readOnly: true }}
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default TimezoneSettings;
